// extracted by mini-css-extract-plugin
export default {"spinButton":"SpinButton_spinButton__YuGmv"};